// extracted by mini-css-extract-plugin
module.exports = {"headerLink":"HeaderLink_headerLink__3jqME","current":"HeaderLink_current__2DAoy"};